import { Box, styled } from "@mui/material";

export const DashboardWrapper = styled(Box)(() => {
    return {
        "& .grid-container": {
            margin: "var(--basic-margin) 0",
        },
        "& .dashboard-card": {
            display: "flex",
            height: "100%",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        },
        "& .icon-box": {
            flex: 0.2,
            overflow: "hidden",
            padding: "var(--basic-padding)",
            "& svg": {
                height: "100%",
                width: "100%",
            }
        },
        "& .label-box": {
            flex: 0.8,
            overflow: "hidden",
            padding: "var(--basic-padding)",
        },
    }
})